export class SessionConflictError extends Error {
  constructor(
    message: string = "You have an active session in another application (e.g., MAX or another browser tab). Please logout from the other session or click 'Force Logout' to disconnect it."
  ) {
    super(message);
    this.name = 'SessionConflictError';
  }
}
